module.exports = __webpack_public_path__ + "img/translate6.3df3a844.jpg";